import { render, staticRenderFns } from "./SellCoinsCampaignList.vue?vue&type=template&id=0639fdf2&scoped=true&"
import script from "./SellCoinsCampaignList.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsCampaignList.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsCampaignList.vue?vue&type=style&index=0&id=0639fdf2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639fdf2",
  null
  
)

export default component.exports